var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(!_vm.hasUser && _vm.isLoading)?_c('LoadingBlock'):_vm._e(),(_vm.hasUser)?_c('RouterView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }